module.exports = __webpack_public_path__ + "img/open_access_interview.869ddd37.jpg";